import React from 'react';
import { RoleAiMarketplace } from '@/components/ai/RoleAiMarketplace';

/**
 * Student AI Tools Marketplace
 * Students have 2 AI tool slots to customize their learning experience
 */
export default function StudentAiMarketplace() {
  return (
    <div className="mx-auto max-w-5xl">
      <RoleAiMarketplace
        role="student"
        title="AI Tools Marketplace"
        description="Browse and activate AI tools to help with your learning. Choose up to 2 tools."
      />
    </div>
  );
}
